<soft-page>
  <soft-page-header>
    <div class="soft-title">
      {{ '#WIEGUNG.SELECT_ACTION' | translate }}
    </div>
  </soft-page-header>

  <div>
    <button type="button" class="soft-button soft-button-primary !p-6 mb-3 width-100 text-center h4" [routerLink]="['/wiegung', 'erstwiegung']">{{ '#WIEGUNG.TITLES.ERSTWIEGUNG' | translate }}</button>
    <button type="button" class="soft-button soft-button-primary !p-6 mb-3 width-100 text-center h4" [routerLink]="['/wiegung', 'materiallieferschein']">{{ '#WIEGUNG.MATERIAL_DELIVERY_NOTE' | translate }}</button>
    <button type="button" class="soft-button soft-button-primary !p-6 mb-3 width-100 text-center h4" [routerLink]="['/wiegung', 'material-retour']">{{ '#WIEGUNG.MATERIAL_DELIVERY_NOTE_RETOUR' | translate }}</button>
    <!-- <button type="button" class="soft-button soft-button-primary !p-6 mb-3 width-100 text-center h4" [routerLink]="['/wiegung', 'zwischenwiegen']">{{ '#WIEGUNG.INTERMEDIATE_WEIGHING' | translate }}</button> -->
    <button type="button" class="soft-button soft-button-primary !p-6 mb-3 width-100 text-center h4" [routerLink]="['/wiegung', 'inventur']">{{ '#WIEGUNG.INVENTORY' | translate }}</button>
    <button type="button" class="soft-button soft-button-primary !p-6 width-100 text-center h4" [routerLink]="['/wiegung', 'gesamt']">{{ '#WIEGUNG.WHOLE' | translate }}</button>
  </div>
</soft-page>
